// extracted by mini-css-extract-plugin
export default {"ConversationDetailPage":"zbSA3uKSY3Q58gaSnAGKLA==","ConversationDetailPageHeader":"FRdwZ0bFi98hjtjB6yCsvA=="};